import ApiModel from "@/deprecated/models/api_client"

export class OnboardingStepModel extends ApiModel {
  constructor(attributes = {}) {
    super("/onboarding/steps", attributes)
  }

  save(attributes = null, options = {}) {
    if (attributes) {
      this.set(attributes)
    }

    // Wrap the data in an onboarding_step object to match Rails expectations
    const wrappedData = { onboarding_step: this.attributes }

    const url = this.urlRoot
    const method = "POST"

    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.getAttribute("content"),
    }

    return fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(wrappedData),
    })
      .then((response) => {
        if (response.ok) {
          if (options.success) {
            options.success(this, response)
          }
          return response
        } else {
          throw new Error("Request failed")
        }
      })
      .catch((error) => {
        if (options.error) {
          options.error(this, error)
        }
        throw error
      })
  }
}
